<template>
  <div class="content-table">
    <div class="content-table-box"
         v-for="(items, indexs) in policys"
         :key="indexs"
         v-show="indexs<showListNum">
      <!--<el-tag class="product-type" v-if="items.supplierType === '7'">{{items.supplierName}}</el-tag>--> <!--productTypeTxt 增加平台自营的标签，所以这个标签隐藏-->

    <table width="99%">
      <!-- <tr>
        <th></th>
        <th>退改规则</th>
        <th>舱位</th>
        <th>座位数</th>
        <th>票面价格</th>
        <th>结算价</th>
        <th></th>
      </tr>-->
      <tr
        class="flight_tr"

      >
        <td width="15%">
          <!-- <el-tag
            :type="items.productTypeTxt=='平台优选'?'success':
            items.productTypeTxt=='低价推荐'?'warning':''"
            effect="dark"
            size="small"
            style="color:white;"
          ></el-tag>-->
          <span
                  :class="{'ico_platform_self ico_tag':items.productTypeTxt=='平台自营'}"
                  v-show="items.productTypeTxt=='平台自营'"
          >{{items.productTypeTxt}}</span>
          <span
            :class="{'ico_platform ico_tag':items.productTypeTxt=='平台优选'}"
            v-show="items.productTypeTxt=='平台优选'"
          >{{items.productTypeTxt}}</span>
          <span
            :class="{'ico_low ico_tag':items.productTypeTxt=='低价推荐'}"
            v-show="items.productTypeTxt=='低价推荐'"
          >{{items.productTypeTxt}}</span>
          <span
            :class="{'ic_official ico_tag':items.productTypeTxt=='官网'}"
            v-show="items.productTypeTxt=='官网'"
          >{{items.productTypeTxt}}</span>
        </td>
        <td>
          <div class="flights-fuel">
            <span @mouseenter="backRule(items),ruleShow=indexs+1">退改规则</span>
            <div class="flights-rules">
              <chang-clause :ruleText="ruleText" :luggage="$attrs.luggage"></chang-clause>
            </div>
          </div>
        </td>
        <td v-once>
          <!-- <span v-if="items.cabin.discount">{{items.cabin.discount}}折</span> -->
          ({{items.cabin.cabinName}}/
          {{$attrs.psgType==2?items.cabin.chdCabinCode:items.cabin.cabinCode}}）
        </td>
        <td>座位数:{{items.cabin.ticketCount >= 9 ? '≥9' : items.cabin.ticketCount}}</td>
        <td width="10%"></td>
        <td class="price">
          <p>
            <sup>￥</sup>
            <!-- <span>{{$parent.checkedTax?items.priceData[0].priceTaxes:items.priceData[0].price}}</span> -->
            <span>{{getPrice(items.priceData[0].price)}}</span>
            <span>票面价</span>
            <!-- <span>票面价（{{!$parent.checkedTax?'含税':'不含税'}}）</span> -->
          </p>
        </td>
        <td class="price">
          <p>
            <sup>￥</sup>
            <span
              style="color:#f60"
            >{{$parent.checkedTax?getPrice(items.priceData[0].settlementPriceTaxes):getPrice(items.priceData[0].rebatePrice)}}</span>
            <span>{{items.policyType === '9999' ? '申请价' : $attrs.creditState?'授信结算价':'结算价'}}（{{$parent.checkedTax?'含税':'不含税'}}）</span>
          </p>
        </td>
        <td>
          <span @click="journeyType(items)" class="btn">{{$attrs.reserveType}}</span>
        </td>
      </tr>
    </table>
    </div>
    <div class="lookMore" v-if="policys.length > 3">
      <p>
        <span @click="showList">{{moreState?'收起':'展开更多'}}</span>
        <i class="el-icon-arrow-down" :class="{'arrowStyle':moreState}"></i>
      </p>
    </div>
  </div>
</template>
<script>
import ChangClause from "./changClause";

export default {
  data() {
    return {
      ruleShow: 0,
      showListNum: 3,
      moreState: false
    };
  },
  props: {
    policys: Array,
    journeyType: Function,
    backRule: Function,
    ruleText: Array,
    loading: Boolean,
    flightsShow: Boolean
  },
  watch: {
    loading(val) {
      this.reset();
    },
    flightsShow(val) {
      this.reset();
    }
  },
  components: { ChangClause },
  methods: {
    reset() {
      this.showListNum = 3;
      this.moreState = false;
    },
    getPrice(val) {
      if (val) {
        return val.toFixed(2);
      } else {
        return 0;
      }
    },
    showList() {
      this.moreState = !this.moreState;
      this.moreState
        ? (this.showListNum = this.policys.length)
        : (this.showListNum = 3);
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
@import url("./css/flight.less");
.content-table {
  background: #f5f8fa;
}
table {
  margin: auto;
  border-collapse: collapse;
  th {
    font-size: 13px;
  }
  td {
    text-align: center;
    word-break: break-word;
    padding: 5px;
    font-size: 12px;
    i {
      font-size: 12px;
      font-style: normal;
    }
  }
}
table td,
table th {
  // border: 1px solid #cad9ea;
  color: #666;
  height: 97px;
  border-bottom: 1px dashed #dfdfdf;
}
.flights-fuel {
  position: relative;
  span {
    color: #237dc9;
    cursor: pointer;
    &:hover + .flights-rules {
      display: block;
      animation: fareAnimation 0.7s ease;
    }
  }
}
.flights-rules {
  position: absolute;
  display: none;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  z-index: 9999;
  min-width: 600px;
  border: 1px solid #237dc9;
}
.flight_tr {
  &:first-of-type {
    border-top: 1px solid #dfdfdf;
  }
}
.ico_tag {
  width: 64px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  border: 1px solid;
  border-radius: 3px;
}
.ico_platform {
  border-color: #0f8f20;
  color: #0f8f20;
}
.ico_platform_self {
  border-color: #408BF9;
  color: #fff;
  background: #408BF9;
}
.ico_low {
  border-color: #ab860e;
  color: #ab860e;
}
.ic_official {
  border-color: #d12190;
  color: #d12190;
}
.btn {
  display: block;
  float: right;
  margin-right: 25px;
  width: 78px;
  height: 37px;
  background: #f60;
  border-radius: 3px;
  color: white;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  cursor: pointer;
}
.price {
  color: #666;
  span:first-of-type {
    font-size: 18px;
    color: #9e9e9e;
    font-family: Microsoft YaHei;
    padding-right: 9px;
  }
}
.arrowStyle {
  transform: rotate(180deg);
}
.lookMore {
  font-size: 12px;
  color: #237dc9;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  background: white;
  span {
    cursor: pointer;
  }
  i {
    transition: all 0.5s ease;
    margin-left: 5px;
  }
}

  .content-table-box {
    position: relative;
    .product-type {
      position: absolute;
      left: 0;
      top: 1px;
      // width: 40px;
      margin-left: 10px;
      margin-right: 10px;
      font-size: 14px;
      color: #666;
      text-align: center;
      // background: #fdfdfd;
    }
  }
</style>